import { Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { SalesPlanImageService } from '../services/salesplan-image.service';

@Directive({
  selector: 'img[appSalesPlanImage]'
})
export class SalesPlanImageDirective implements OnChanges, OnDestroy {
  @Input() salesPlanId!: number;
  @Input() imageId!: number;
  @Input() fileIndex!: number;

  private imageSubscription?: Subscription;
  private readonly loaderUrl = 'assets/images/loader_btn.gif';

  constructor(
    private elementRef: ElementRef<HTMLImageElement>,
    private renderer: Renderer2,
    private salesPlanImageService: SalesPlanImageService
  ) { }

  ngOnChanges(): void {
    // console.log('directive onChanges', this.salesPlanId, this.imageId, this.fileIndex);
    this.imageSubscription?.unsubscribe();

    if (this.salesPlanId && this.imageId) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'src', this.loaderUrl);
      this.imageSubscription = this.salesPlanImageService
        .getImageUrl(this.salesPlanId, this.imageId, this.fileIndex)
        .subscribe(imageUrl => {
          this.renderer.setAttribute(this.elementRef.nativeElement, 'src', imageUrl ?? this.loaderUrl);
        });
    }
  }

  ngOnDestroy(): void {
    this.imageSubscription?.unsubscribe();
  }
}
